import { render, staticRenderFns } from "./AccountPostingReceipt.vue?vue&type=template&id=36139d61&"
import script from "./AccountPostingReceipt.vue?vue&type=script&lang=js&"
export * from "./AccountPostingReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports